var map = {
	"./balance_Belarus.png": 6663,
	"./balance_Bulgaria.png": 4884,
	"./balance_Czech-Republic.png": 1993,
	"./balance_Georgia.png": 8031,
	"./balance_Kazakhstan.png": 7669,
	"./balance_Lithuania.png": 8422,
	"./balance_Poland.png": 3071,
	"./balance_Serbia.png": 633,
	"./balance_Ukraine.png": 6844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3670;